<template>
    <div>
        <div>
            <div class="text-h4 text-weight-medium">
                {{ $t('System Status') }}
            </div>
            <div class="page-description">
                {{
                    $t(
                        ' Monitor the health and performance of the LEAN system.'
                    )
                }}
            </div>
        </div>
        <iframe
            id="status"
            src="https://status.iotorq-lean.com/"
            class="status-iframe"
        >
        </iframe>
    </div>
</template>

<script>
import BreadcrumbsManager from '@mixins/BreadcrumbsManager.vue';

export default {
    name: 'SystemAvailability',
    mixins: [BreadcrumbsManager],
    mounted() {
        // set breadcrumbs
        this.setBreadcrumbs([
            {
                label: this.$t('Facilities'),
                route: {
                    name: 'facility_list'
                }
            },
            {
                label: this.$t('Global Settings'),
                route: {
                    name: 'settings'
                }
            },
            {
                label: this.$t('System Status')
            }
        ]);
    }
};
</script>

<style lang="scss" scoped>
.status-iframe {
    width: 100%;
    height: 100vh;
}
</style>
